import { useState } from "react";
import { Tooltip, Stack } from "@mui/material";
import { useLocation, useNavigate } from "react-router";
import { useAuth0 } from "@auth0/auth0-react";
import { SettingsButton } from "./HeaderBarButtons/SettingsButton";
import { ProfileButton } from "./HeaderBarButtons/ProfileButton";
import { SignoutButton } from "./HeaderBarButtons/SignoutButton";
import { AdminButton } from "./HeaderBarButtons/AdminButton";
import { EditportalButton } from "./HeaderBarButtons/EditportalButton";
import { DevButton } from "./HeaderBarButtons/DevButton";

export default function HeaderBarIconMenu({...params}) {

    const { isAuthenticated, logout } = useAuth0();
    const navigate = useNavigate();
    const location = useLocation();

    let page = params.page
    let channelID = params.channelID
    let canEdit = params.canEdit
    let isAdmin = params.isAdmin


    let startingSettingsButtonState = 'default'
    let startingProfileButtonState = 'default'
    let startingSignoutButtonState = 'default'

    let startingAdminButtonState = 'default'
    let startingEditportalButtonState = 'default'
    let startingDevButtonState = 'default'

    let url = window.location.pathname
    if (url === '/settingspage') startingSettingsButtonState = 'active'
    else if (url === '/profilepage') startingProfileButtonState = 'active'
    else if (url === '/adminpage') startingAdminButtonState = 'active'
    else if (url === ('/editpage/' + channelID)) startingEditportalButtonState = 'active'
    else if (url === '/devpage') startingDevButtonState = 'active'

    const [settingsButtonState, setSettingsButtonState] = useState(startingSettingsButtonState)
    const [profileButtonState, setProfileButtonState] = useState(startingProfileButtonState)
    const [signoutButtonState, setSignoutButtonState] = useState(startingSignoutButtonState)

    const [adminButtonState, setAdminButtonState] = useState(startingAdminButtonState)
    const [editportalButtonState, setEditportalButtonState] = useState(startingEditportalButtonState)
    const [devButtonState, setDevButtonState] = useState(startingDevButtonState)

    const setAllButtonsToDefault = () => {
        setSettingsButtonState('default')
        setProfileButtonState('default')
        setSignoutButtonState('default')
        setAdminButtonState('default')
        setEditportalButtonState('default')
        setDevButtonState('default')
    }

    const handleSettingsButtonClick = (event) => {
        event.preventDefault()
        setAllButtonsToDefault()
        setSettingsButtonState('active')
        if (url !== '/settingspage') navigate('/settingspage')
    };

    const handleProfileButtonClick = (event) => {
        event.preventDefault()
        setAllButtonsToDefault()
        setProfileButtonState('active')
        if (url !== '/profilepage') navigate('/profilepage')
    };

    const handleSignoutButtonClick = (event) => {
        event.preventDefault()
        setAllButtonsToDefault()
        setSignoutButtonState('active')
        logout({ logoutParams: { returnTo: window.location.origin } })
    };

    const handleAdminButtonClick = (event) => {
        event.preventDefault()
        setAllButtonsToDefault()
        setAdminButtonState('active')
        if (url !== '/adminpage') navigate('/adminpage')
    };

    const handleEditportalButtonClick = (event) => {
        event.preventDefault()
        setAllButtonsToDefault()
        setEditportalButtonState('active')
        if (url !== '/editpage/' + channelID) navigate('/editpage/' + channelID)
    };

    const handleDevButtonClick = (event) => {
        event.preventDefault()
        setAllButtonsToDefault()
        setDevButtonState('active')
        if(location.pathname === "/devpage"){
            navigate("/stationspage")
        }else{
            navigate("/devpage")
        }
    };

    let labelFormatting = {
        fontWeight: 600,
        fontSize: '14px',
        textAlign: 'center',
        verticalAlign: 'middle',
        color: 'primary.main',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '-0.42px',
    }

    let showAdminAndEditAndDevButtons = true

    return (
        <>
            <Stack direction={'row'} spacing={'50px'} display={'flex'} justifyContent={'center'} height={'95px'} width={'1444px'} padding={'22px 50px'}>
                {isAuthenticated && (
                    <>
                        <SettingsButton labelFormatting={labelFormatting} settingsButtonState={settingsButtonState} setSettingsButtonState={setSettingsButtonState} handleClick={handleSettingsButtonClick} />
                        <ProfileButton labelFormatting={labelFormatting} profileButtonState={profileButtonState} setProfileButtonState={setProfileButtonState} handleClick={handleProfileButtonClick} />
                        <SignoutButton labelFormatting={labelFormatting} signoutButtonState={signoutButtonState} setSignoutButtonState={setSignoutButtonState} handleClick={handleSignoutButtonClick} />
                        
                        {isAdmin && showAdminAndEditAndDevButtons && (
                            <AdminButton labelFormatting={labelFormatting} adminButtonState={adminButtonState} setAdminButtonState={setAdminButtonState} handleClick={handleAdminButtonClick} />
                        )}

                        {((page === "ChannelPage" || page === 'EditPage') && canEdit && showAdminAndEditAndDevButtons) && (
                            <EditportalButton labelFormatting={labelFormatting} editportalButtonState={editportalButtonState} setEditportalButtonState={setEditportalButtonState} handleClick={handleEditportalButtonClick} />
                        )}

                        {(page === "StationsPage" && isAdmin && showAdminAndEditAndDevButtons) && (
                            <Tooltip title="Switch Mode">
                                <DevButton labelFormatting={labelFormatting} devButtonState={devButtonState} setDevButtonState={setDevButtonState} handleClick={handleDevButtonClick} />
                            </Tooltip>
                        )}
                    </>
                )}
            </Stack>
        </>
    );
}
